import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import { useMemo } from 'react'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface OshaHipaaProps {
  link: string
}

const OshaHipaa = ({ link }: OshaHipaaProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  const complianceData = useMemo(() => {
    if (!metadata) return null

    const { osha_hipaa_compliance_status, osha_hipaa_message_long: message } = metadata
    const hasCurrentItems = osha_hipaa_compliance_status !== ComplianceStatus.Inactive

    return {
      message,
      osha_hipaa_compliance_status,
      hasCurrentItems,
      hasPreviousItems: !hasCurrentItems,
    }
  }, [metadata])

  return metadata && complianceData && (
    <Box>
      {!complianceData?.hasCurrentItems ? (
        <div>
          <p>Access your <Link href={link}>OSHA and HIPAA</Link> plans</p>
        </div>
      ) : (
        <div className="border-box">
          <div>
            <CompliancePlip message='' className='dashboard-compliance' status={complianceData?.osha_hipaa_compliance_status} />
          </div>
          <div className='compliance-message'>
            <p>{complianceData?.message}</p>
            <Link className='small-text' href={link}>View Details</Link>
          </div>
        </div>
      )}
    </Box>
  )
}
export default OshaHipaa